import ApiService from "@/api";
import GetTemplateListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-tempalte/request/GetTemplateListRequest";
import RemoveTemplateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-tempalte/request/RemoveTemplateRequest";
import { ParametersTemplateModel, TaskParameterTypeEnum } from "@/components";
import { ResponseModel } from "@/models";
import { SendErrorNotification } from "../functions";
import UpsertTemplateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-tempalte/request/UpsertTemplateRequest";

/**Сервис для управление шаблонами параметров задачи */
export class TaskParametersTemplateService {
  /**Сервис для использования API */
  api = new ApiService();

  /**Получить список шаблонов */
  GetTemplateList(type: TaskParameterTypeEnum) {
    return new Promise<ResponseModel<ParametersTemplateModel[]>>(async (resolve) => {
      const result = new ResponseModel<ParametersTemplateModel[]>();

      await this.api.Main.SettingQueueTaskTemplateService.getTemplateListAsync(
        new GetTemplateListRequest({ Type: type as any }),
      )
        .then((response) => {
          result.Value = response.Items.map((x) => new ParametersTemplateModel(x as any));
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
  /**Удалить шаблон */
  RemoveTemplate(templateId: string) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.SettingQueueTaskTemplateService.removeTemplateAsync(
        new RemoveTemplateRequest({
          TemplateId: templateId,
        }),
      )
        .then((response) => {
          result.Value = !!response;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
  /**Добавить/Обновить шаблон */
  UpsertTemplate(template: ParametersTemplateModel) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.SettingQueueTaskTemplateService.upsertTemplateAsync(
        new UpsertTemplateRequest({
          TemplateId: template.Id,
          Name: template.Name,
          Data: template.Data,
          Type: template.Type as any,
        }),
      )
        .then((response) => {
          result.Value = !!response;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
}
